import { createLucideIcon } from 'lucide-react';

// Lucide has Apple icon already, so we need to create a new one for iOS
export const AppleIos = createLucideIcon('AppleIos', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M20.25 8.09c-.125.097-2.342 1.347-2.342 4.125 0 3.213 2.821 4.35 2.906 4.378-.013.07-.449 1.557-1.488 3.073-.927 1.333-1.895 2.665-3.367 2.665s-1.851-.855-3.551-.855c-1.656 0-2.245.883-3.592.883s-2.287-1.234-3.367-2.75c-1.252-1.78-2.263-4.545-2.263-7.169 0-4.21 2.737-6.442 5.43-6.442 1.432 0 2.625.94 3.524.94.855 0 2.189-.996 3.817-.996.617 0 2.834.056 4.294 2.148m-5.066-3.93c.673-.799 1.15-1.908 1.15-3.016 0-.154-.013-.31-.041-.436-1.096.042-2.4.73-3.186 1.642-.617.701-1.193 1.81-1.193 2.934 0 .169.028.338.041.392.07.013.182.028.295.028.983 0 2.22-.658 2.934-1.544',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
